<template>
  <div class="wrap">
    <div class="header">
      <div class="header-title" @click="$router.push('/')">
        智慧园区
      </div>

      <div class="header-modules">
        <div class="module-item" @click="jumpPage('事件中心')">事件中心</div>
        <div class="module-item" @click="jumpPage('巡检中心')">巡检中心</div>
        <div class="module-item" @click="jumpPage('服务商管理')">服务商管理</div>
        <div class="module-item" @click="jumpPage('资产管理')">资产管理</div>
      </div>

      <div class="header-personal">
        <currentTime style="width: 60%;"/>
        <PersonalCenter style="width: 30%"/>
      </div>
    </div>

    <div class="main">
      <router-view></router-view>
    </div>
  </div>

</template>

<script>
import PersonalCenter from "@/components/profile/PersonalCenter";
import currentTime from "@/components/current-time/current-time";
import Event from "@/page/event/Event";

export default {
  name: "HomePage",
  components: {Event, PersonalCenter, currentTime},
  data() {
    return {
      activeKey: 0
    }
  },
  methods: {
    jumpPage(type) {
      switch (type) {
        case '事件中心':
          this.$router.push('/events-center');
          break;
        case '巡检中心':
          this.$router.push('/patrol-center');
          break;
        case '服务商管理':
          this.$router.push('/vendor-manage');
          break;
        case '资产管理':
          this.$router.push('/asset-manage');
          break;
        default:
        this.$router.push('/');
          break;
      }
    }
  }
}
</script>

<style scoped lang="scss">
.wrap {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #1a262b;

  .header {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background-image: url("@/assets/image/page-header.png");
    background-repeat: no-repeat;
    background-size: 100%;
    height: 9vh;

    .header-title {
      width: 8%;
      font-size: 1.8rem;  
      font-weight: 600;   
      color: white;
      cursor: pointer;
      line-height: 9vh;
      margin-left: 2rem;
      font-style: italic;
    }

    .header-modules {
      display: flex;
      align-items: center;
      .module-item {
        color: #fff;
        font-size: 1.1rem;
        margin-right: 2rem;
        cursor: pointer;
        padding: 0 1.2rem;
        height: 40px;
        line-height: 40px;
        border-radius: 5px;
        background: rgba(24, 144, 255, 0.08);
        transition: background 0.2s, color 0.2s;
        &:hover {
          background: rgba(198, 220, 241, 0.08);
          color: #fff;
        }
      }
    }

    .header-personal {
      height: 70%;
      width: 13%;
      display: flex;
      cursor: pointer;
      justify-content: space-around;
    }

    .header-navi {
      flex: 1;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: flex-end;
      padding: 0 5rem;

      .navi-item {
        color: white;
        font-size: 1rem;
        border-radius: 5%;
        background-color: #2c373c;
        border: #2c373c 1px solid;
        margin-right: 2rem;
        width: vw(150);
        height: vh(40);
        line-height: vh(40);
        cursor: pointer;
      }

      .active {
        color: #1890FF;
      }

      .navi-item:active {
        color: #1890FF;
      }
    }
  }

  .main {
    position: absolute;
    bottom: 0;
    height: 90vh;
    width: 100%;
  }
}


</style>
